<template>
  <v-dialog :value="open" @click:outside="closeDialog()" scrollable max-width="500">
    <ValidationObserver ref="searchFormObs" v-slot="{ handleSubmit }">
      <v-card :loading="isLoading">
        <v-card-title class="pa-0 shadow-1">
          <v-img
            :src="require('@/assets/illustrations/bg_modal_card.svg')"
            cover
            position="left bottom"
            class="align-center"
            height="65px"
          >
            <v-card-title class="font-weight-medium primary--text">
              Buscar Cita
            </v-card-title>
          </v-img>
        </v-card-title>

        <vuescroll
          :ops="{
            bar: { background: '#bacfcec0', keepShow: true },
          }"
        >
          <v-card-text style="max-height: 570px">
            <v-form>
              <v-row dense>
                <!-- Telefono -->
                <v-col cols="12">
                  <ValidationProvider name="telefono" v-slot="{ errors }">
                    <v-text-field
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Teléfono"
                      v-model="formData.search_phone"
                      :error-messages="errors"
                    />
                  </ValidationProvider>
                </v-col>

                <!-- Contacto -->
                <v-col cols="12">
                  <ValidationProvider name="contacto" v-slot="{ errors }">
                    <v-text-field
                      filled
                      rounded
                      class="rounded-small"
                      dense
                      label="Contacto"
                      v-model="formData.search_contact"
                      :error-messages="errors"
                    />
                  </ValidationProvider>
                </v-col>

                <!-- Template -->
                <v-col cols="12">
                  <ValidationProvider name="Plantilla" v-slot="{ errors }">
                    <v-autocomplete
                      filled
                      rounded
                      clearable
                      :loading="isLoadingTemplates"
                      class="rounded-small"
                      dense
                      label="Plantilla"
                      :items="templateList"
                      item-text="title"
                      item-value="id"
                      color="blue-grey"
                      v-model="formData.template_id"
                      :error-messages="errors"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>

                <!-- Date -->
                <v-col cols="12" v-if="open">
                  <ValidationProvider name="Fecha">
                    <v-menu
                      v-model="dateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template
                        v-slot:activator="{
                          on,
                          attrs,
                        }"
                      >
                        <ValidationProvider name="Fecha" v-slot="{ errors }">
                          <v-text-field
                            v-model="formData.appointment_date"
                            label="Fecha"
                            class="rounded-small"
                            readonly
                            filled
                            required
                            rounded
                            v-bind="attrs"
                            v-on="on"
                            :error-messages="errors"
                          ></v-text-field>
                        </ValidationProvider>
                      </template>
                      <v-date-picker
                        v-model="formData.appointment_date"
                        no-title
                        scrollable
                        @input="dateMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </ValidationProvider>
                </v-col>

                <!-- Especialidad -->
                <v-col cols="12">
                  <ValidationProvider name="Especialidad" v-slot="{ errors }">
                    <v-autocomplete
                      filled
                      rounded
                      clearable
                      :loading="isLoadingSpecialties"
                      class="rounded-small"
                      dense
                      label="Especialidad"
                      :items="specialtiesList"
                      item-text="name"
                      item-value="id"
                      color="blue-grey"
                      v-model="formData.specialty_id"
                      :error-messages="errors"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>

                <!-- Responsable -->
                <v-col cols="12">
                  <ValidationProvider name="Responsable" v-slot="{ errors }">
                    <v-autocomplete
                      filled
                      rounded
                      clearable
                      :loading="isLoadingResponsible"
                      class="rounded-small"
                      dense
                      label="Responsable"
                      :items="responsibleList"
                      item-text="name"
                      item-value="id"
                      color="blue-grey"
                      v-model="formData.responsible_id"
                      :error-messages="errors"
                    ></v-autocomplete>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </vuescroll>

        <v-divider></v-divider>

        <v-card-actions class="mx-2">
          <v-spacer></v-spacer>

          <v-hover v-slot:default="{ hover }">
            <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="closeDialog()">Cancelar</v-btn>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-btn
              rounded
              :loading="isLoading"
              :disabled="isLoading"
              color="success"
              :class="hover ? 'shadow-2' : 'shadow-4'"
              class="px-8"
              @click.stop="handleSubmit(submitForm)"
            >
              Enviar
            </v-btn>
          </v-hover>
        </v-card-actions>
      </v-card>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import vuescroll from "vuescroll";
import { PbxHttpClient } from "@/services/httpclient";

export default {
  components: { vuescroll },
  props: {
    open: {
      type: Boolean,
    },
    hasFiltersApplied: {
      type: Boolean,
    },
  },
  data() {
    return {
      isLoading: false,
      isLoadingTemplates: false,
      isLoadingContacts: false,
      dateMenu: false,
      templateList: [],
      contactList: [],
      isLoadingSpecialties: false,
      isLoadingResponsible: false,
      specialtiesList: [],
      responsibleList: [],
      formData: {
        search_phone: "",
        search_contact: "",
        appointment_date: "",
        template_id: undefined,
        specialty_id: undefined,
        responsible_id: undefined,
      },
    };
  },

  watch: {
    open(val) {
      if (val) {
        this.getTemplates();
        this.getSpecialties();
        this.getResponsibles();
        if (!this.hasFiltersApplied) {
          this.formData = {
            search_phone: "",
            search_contact: "",
            appointment_date: "",
            template_id: undefined,
            specialty_id: undefined,
            responsible_id: undefined,
          };
        }
      }
    },
  },

  methods: {
    closeDialog(searchParams, prettySearchParams) {
      this.$emit("dialog:close", { searchParams, prettySearchParams });
    },

    async getTemplates() {
      this.isLoadingTemplates = true;
      try {
        const { data } = await PbxHttpClient.get("/module_appointment/templates_appointments", {
          params: { page: 1, itemPerPage: 100 },
        });
        this.templateList = data.data;
      } catch (error) {
        console.log(error);
      }
      this.isLoadingTemplates = false;
    },

    async getSpecialties() {
      this.isLoadingSpecialties = true;
      try {
        const { data } = await PbxHttpClient.get("/module_appointment/specialties_select");
        this.specialtiesList = data;
      } catch (error) {
        console.log(error);
      }
      this.isLoadingSpecialties = false;
    },

    async getResponsibles() {
      this.isLoadingResponsible = true;
      try {
        const { data } = await PbxHttpClient.get("/module_appointment/responsibles_select");
        this.responsibleList = data.map((el) => ({ ...el, name: `${el.name} ${el.last_name}` }));
      } catch (error) {
        console.log(error);
      }
      this.isLoadingResponsible = false;
    },

    async submitForm() {
      const prettySearchParams = {
        plantilla: this.templateList.find((el) => el.id === this.formData.template_id)?.title,
        fecha: this.formData.appointment_date || undefined,
        responsable: this.responsibleList.find(({ id }) => id === this.formData.responsible_id)
          ? `${this.responsibleList.find(({ id }) => id === this.formData.responsible_id).name} ${
              this.responsibleList.find(({ id }) => id === this.formData.responsible_id).last_name
            }`
          : undefined,
        especialidad: this.specialtiesList.find(({ id }) => id === this.formData.specialty_id)?.name,
      };

      this.closeDialog(
        { ...this.formData, appointment_date: this.formData.appointment_date || undefined },
        prettySearchParams,
      );
    },
  },
};
</script>
